import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./api.d"; // openapi-typescriptで生成された型
const baseUrl = import.meta.env.VITE_API_URL;

const fetchClient = createFetchClient<paths>({
  baseUrl: baseUrl ? `${baseUrl}/api/v1/` : '/api/v1/',
});
export const create = () => {
  return createClient(fetchClient);
}
